export default class CallTest {
  static [Symbol.hasInstance](obj: any) {
    if (obj.URL && obj.Title && obj.Summary && obj.Key) return true;
  }

  public Title = "";
  public Key = "";
  public Summary = "";
}
